var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('PluginHeader',{attrs:{"title":"Translator","subtitle":"Translate one dataset to another via sample points","icon":"fas fa-sort-shapes-up"}}),_c('Alert'),_c('Options'),_c('TranslationMap'),_c('Menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }